<template>
    <div class="home container">
      <div class="row">
        <div class="col"><img v-bind:src="image" alt="peinture" /></div>
        <div class="col">
          
          <p>En peinture, on fait tout faire dire à la couleur, même peut-être ce qui n’est pas de sa nature. A côté de l’art contemporain arlequiné de tous ses extrêmes, en sont venus en moi, le souci de la mesure et celui de la nécessité de l’intériorité, en vue de réconcilier l’image et le sens.</p>
          <p>Est né le recours au MONOCHROMATISME, comme moyen de servir un objet à jamais ouvert, la SUBLIMITE du FEMININ, allégorie de notre humanité, par le biais d’une FIGURATION « SUBREALISTE », et tenter une approche POETIQUE et ESTHETIQUE de L’ETANT comme incontournable chemin vers l’ETRE…</p>
          <button type="button" class="btn btn-secondary btn-lg" data-toggle="modal" data-target="#exampleModal">En Savoir plus... </button>
          <!-- Modal -->
          
          <div class="modal fade" id="exampleModal">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header titreColorImg">
                    <h5 class="modal-title " id="exampleModalLabel">En savoir plus...</h5>
                    <button type="button" class="close titreColorImg" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>              
                  </div>
                  <div class="modal-body">
                    <p>Tenter de dire le maximum de choses en usant par la monochromie du minimum de moyens, est un peu observer le monde qui est nôtre, et la création qui
                      est notre relation à lui, avec la distance respectueuse, méditative, qui suggère tant la fragilité et l’éphémère de notre condition.</p>
                      <p>Dire de même ou s’aider du féminin, allégorie de notre humanité, sans cesse remise en question, jamais véritablement atteinte, pour guider tout à la
                      fois, notre travail et nos pas… </p>
                      <p>Mon projet pictural consiste plus en une réflexion sur la distance qui peut exister entre l’essence des choses et la représentation qu’on s’en fait. Par le biais d’une
                      représentation figurative, et au moyen d’un langage plastique cohérent se suffisant à lui-même, je voudrais dénoncer les faux-semblants en les mettant, parfois avec ironie, en images. Présenter les
                      masques que la femme peut se donner, tout en suggérant, la plupart du temps, celle qui se cache derrière, c’est décrire, métaphoriquement, l’humanité dont nous sommes fait. Ces masques ne sont que
                      traces de l’âme: ils sont le reflet d’un monde parti en déshérence. Toujours, il nous faut accorder une chance à l’esprit de déceler le fond des choses, ceci en tentant de percer à jour le
                      secret des masques, de n’être pas dupe de soi, en puisant dans les vestiges du passé, en renonçant à cette idée de la <em>tabula rasa</em>, pour y quérir les éléments de notre développement.
                      Toujours, ce fond des choses a pris pour moi, quelle qu’en soit l’apparence, le visage sublimé d’une figure féminine.</p>
                      <p>Quête spirituelle donc en dernière analyse, que ce désir constant de métamorphoser cet objet des sens qu’est le corps féminin en objet d’études et d’introspection pour
                      l’esprit. Mais bien évidemment, cette quête n’a de sens que si l’objet des sens est encore visible et identifiable. C’est la raison d’être, après tout, de la peinture que de présenter des objets
                      visibles, en cela, je me tiens à l’écart de l’art contemporain. Si nous élaborons une réflexion sur la représentation, l’artiste contemporain se complaît dans des concepts purs, alors que je voudrais
                      encore inspirer une réflexion sur les objets sensibles qui sont ceux de notre monde, avec lesquels il nous faut marquer d’une humanité si ténue soit-elle, la trace de nos vies. Pour montrer aussi que
                      plaisir des yeux et réflexions intellectuelles peuvent être compatibles, et qu’ils sont même tout à fait accordables dans ce qu’on a coutume d’appeler l’œuvre d’art.</p>
                      <p>Bernard FIEVRE</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-lg" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
          </div> 
        </div>
      </div>
    </div>
</template>

<script>

const image='http://bernardfievre.fr/images/accueil/penture1.jpg';
export default {
  name: 'Home',
  data:() =>{
    return{
      image,
    }
  },
  methods:{
  
  },
  created: function(){
     localStorage.setItem('test', 'false');
  },
}
</script>

<style>
.more-info-enter-active {
  transition: all 3s ease;
}
.more-info-leave-active {
  transition: all 8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.more-info-enter, .more-info-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.titreColorImg{
  background-color: #3f3f3f!important;
  color: #d5d5d5!important;
}
</style>